/* eslint-disable react/require-default-props */
import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';

import { WhiteCircularProgress } from '../../../../../../components/UI/Typography';
import { DialogContainer, OutlinedButton, StyledDialog } from '../styles';

interface CancelDocumentDialogProps {
  docId: number;
  name: string;
  disabled: boolean;
  handleCancel?: (docId: number) => Promise<void>;
}

export function CancelDocumentDialog({
  docId,
  name,
  disabled,
  handleCancel,
}: CancelDocumentDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    setLoading(true);
    handleCancel?.(docId)?.then(() => handleClose());
  };

  return (
    <>
      {/* Without a cancel handler the confirmation would leave the dialog
      stuck on its loading state, so the action is not offered at all: the
      table is reused in contexts where cancelling a request does not apply. */}
      <OutlinedButton
        sx={{ maxWidth: '280px' }}
        onClick={handleOpen}
        disabled={disabled || !handleCancel}
      >
        cancelar
      </OutlinedButton>
      <StyledDialog open={open} onClose={handleClose}>
        <DialogContainer>
          <Typography fontSize={18} textAlign="center" mb={2}>
            A solicitação do documento{' '}
            <span style={{ fontWeight: '600' }}>{name}</span> será cancelada.
          </Typography>
          <Typography sx={{ color: '#595959', textAlign: 'center' }}>
            Atenção! Esta ação não poderá ser desfeita.
          </Typography>
          <Box display="flex" justifyContent="center" gap={2} m={3}>
            <OutlinedButton
              disabled={loading}
              sx={{ maxWidth: '200px', width: '200px', height: '48px' }}
              onClick={handleClose}
            >
              cancelar
            </OutlinedButton>
            <Button
              sx={{ width: '200px', height: '48px' }}
              disabled={loading}
              onClick={handleConfirm}
            >
              {loading ? <WhiteCircularProgress size={22} /> : 'confirmar'}
            </Button>
          </Box>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
